var clientId

switch (window.location.host.split('.')[0]) {
  case 'spop':
    switch (window.location.host.split('.')[1]) {
      case 'umaxdata':
        clientId = 'hkspop'
        break
      case 'ersinfotech':
        clientId = 'spop'
        break
      default:
        clientId = 'spop'
    }
    break
  case 'spop-umac':
    clientId = 'spop'
    break
  case '0-spop-hksyu':
  case '0-spop--hksyu-umaxdata-com':
  case 'spop-hksyu':
  case 'hkspop':
    clientId = 'hkspop'
    break
  default:
    clientId = 'spop'
}

module.exports = clientId



/*****************
 ** WEBPACK FOOTER
 ** ./clientId.js
 ** module id = 665
 ** module chunks = 0 5
 **/